export default __webpack_public_path__ + "static/media/active-projects.dc7d824e.svg";